import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// types.
import { Theme } from '../utils/types';

//	--------------------------------------------------------------------------
//
//	T Y P E S
//
//	--------------------------------------------------------------------------

export interface SettingsState {
  theme?: Theme;
  language?: string;
  iconSize?: string;
  fontSize?: number;
  defaultProject?: number;
  defaultSiteUUID?: string;
  popupNotificationsEnabled?: boolean;
  popupLogsEnabled?: boolean;
  settingsLoaded: boolean;
}

//	--------------------------------------------------------------------------
//
//	C O N S T A N T S
//
//	--------------------------------------------------------------------------

const initialState: SettingsState = {
  theme: Theme.AUTO,
  language: 'en',
  iconSize: 'medium',
  fontSize: 10,
  defaultProject: undefined,
  defaultSiteUUID: undefined,
  popupNotificationsEnabled: true,
  popupLogsEnabled: true,
  settingsLoaded: false,
};

//	--------------------------------------------------------------------------
//
//	S L I C E S
//
//	--------------------------------------------------------------------------

export const settingsSlice = createSlice({
  name: 'settings',
  initialState: initialState,
  reducers: {
    //
    rS_setThemeSetting: (state: SettingsState, action: PayloadAction<Theme>) => {
      state.theme = action.payload;
    },

    rS_setLanguageSetting: (state: SettingsState, action: PayloadAction<string>) => {
      state.language = action.payload;
    },

    rS_setIconSizeSetting: (state: SettingsState, action: PayloadAction<string>) => {
      state.iconSize = action.payload;
    },

    rS_setFontSizeSetting: (state: SettingsState, action: PayloadAction<number>) => {
      state.fontSize = action.payload;
    },

    rS_setDefaultProjectSetting: (
      state: SettingsState,
      action: PayloadAction<number | undefined>,
    ) => {
      state.defaultProject = action.payload;
    },

    rS_setDefaultSiteUUIDSetting: (
      state: SettingsState,
      action: PayloadAction<string | undefined>,
    ) => {
      state.defaultSiteUUID = action.payload;
    },

    rS_setPopupNotificationsEnabledSetting: (
      state: SettingsState,
      action: PayloadAction<boolean>,
    ) => {
      state.popupNotificationsEnabled = action.payload;
    },

    rS_setPopupLogsEnabledSetting: (
      state: SettingsState,
      action: PayloadAction<boolean>,
    ) => {
      state.popupLogsEnabled = action.payload;
    },

    rS_setSettingsLoaded: (state: SettingsState, action: PayloadAction<boolean>) => {
      state.settingsLoaded = action.payload;
    },
    //
  },
});

// expose the interface.
export const {
  rS_setThemeSetting,
  rS_setLanguageSetting,
  rS_setIconSizeSetting,
  rS_setFontSizeSetting,
  rS_setDefaultProjectSetting,
  rS_setDefaultSiteUUIDSetting,
  rS_setPopupNotificationsEnabledSetting,
  rS_setPopupLogsEnabledSetting,
  rS_setSettingsLoaded,
} = settingsSlice.actions;
export default settingsSlice.reducer;
